import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const modules = RepositoryFactory.get("modules");

export default {
  getModules({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await modules.getModules(payload);

        await commit("SET_MODULES", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  update({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await modules.updateIntellectual(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
